import Card from "../UI/Card/Card";
import Icon from "../UI/Icon/Icon";
import IconList from "../UI/IconList/IconList";

export default (props) => {
  const state = props.state ? props.state : "default";
  const contract = props.contract ? props.contract : false;

  const dateOpenFormatted = new Date(contract.dateOpen).toLocaleDateString();
  const dateUpdatedFormatted = new Date(
    contract.dateUpdated
  ).toLocaleDateString();

  const deadlineFormatted = contract.deadline ? new Date(contract.deadline).toLocaleDateString() : "";

  const contractStatuses = ["открыта", "в работе", "завершено"];

  function getContractStatus(status) {
    if (!status && status != 0) return "Ошибка";
    return contractStatuses[+status];
  }
  
  if (contract)
    return (
      <Card
        size="small"
        className="Cards-list__item"
        state={state}
        key={props.id}
        button={props.button}
        buttonOnClick={props.onTakeContract}
      >
        <div className="Flex-container Card__section">
          <div className="Card__title Flex-col">{contract.name}</div>
          <div className="Flex-col">
            <Icon
              className="Card__icon"
              image="clock"
              title={deadlineFormatted}
            />
          </div>
        </div>
        <div className="Card__body">
          <IconList className="Card__section">
            {"rewardPrice" in contract && contract.rewardPrice ? (
              <Icon
                className="Card__icon Icon-list__item"
                image="baf"
                size="m2" //custom for this icon
                title={contract.rewardPrice}
              />
            ) : (
              ""
            )}
            {"rewardperk" in contract && contract.rewardperk ? (
              <Icon
                className="Card__icon Icon-list__item"
                image={contract.rewardperkIcon}
                size="s" 
                title={""}
              />
            ) : (
              ""
            )}
            {"rewardskil" in contract && contract.rewardskil ? (
              <Icon
                className="Card__icon Icon-list__item"
                image={contract.rewardskilIcon}
                size="s" 
                title={""}
              />
            ) : (
              ""
            )}
          </IconList>

          <div className="Card__section">
            {contract.dateOpen && (
              <div>
                <b>Создано:</b> {dateOpenFormatted}
              </div>
            )}
            {contract.dateUpdated && (
              <div>
                <b>Обновлено:</b>
                {dateUpdatedFormatted}
              </div>
            )}
            {contract.party && (
              <div>
                <b>Выполняет:</b> {"partyName" in contract && contract.partyName}
              </div>
            )}
            {"status" in contract ? (
              <div>
                <b>Статус:</b> {getContractStatus(contract.status)}
              </div>
            ) : (
              ""
            )}
          </div>
          <div className="Card__section">{contract.terms}</div>
        </div>
      </Card>
    );
};
